import React, { createContext, useContext, useState, useCallback } from 'react';

const ReorderModeContext = createContext();

export function useReorderMode() {
  const context = useContext(ReorderModeContext);
  if (!context) {
    throw new Error('useReorderMode must be used within a ReorderModeProvider');
  }
  return context;
}

export function ReorderModeProvider({ children }) {
  const [isReorderMode, setIsReorderMode] = useState(false);

  const enableReorderMode = useCallback(() => setIsReorderMode(true), []);
  const disableReorderMode = useCallback(() => setIsReorderMode(false), []);
  const toggleReorderMode = useCallback(() => setIsReorderMode(prev => !prev), []);

  const value = {
    isReorderMode,
    enableReorderMode,
    disableReorderMode,
    toggleReorderMode,
  };

  return (
    <ReorderModeContext.Provider value={value}>
      {children}
    </ReorderModeContext.Provider>
  );
}
